import React from "react";
import { Phone } from "lucide-react";
import { Button } from "./ui/button";
import { company, heroImage } from "../mock";

const Hero = () => {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Luxury tropical pool with palm trees"
          className="w-full h-full object-cover"
          style={{ filter: "saturate(1.75) brightness(1.12) contrast(1.08)" }}
        />
        {/* Clean, bright pool overlay — crisp turquoise */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a5c96]/62 via-[#16b6e0]/18 to-[#0a5c96]/55" />
        <div className="absolute inset-0 bg-[#22d3ee]/12 mix-blend-screen" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#062038]/55 via-transparent to-[#22d3ee]/12" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-8 w-full pt-28 pb-16">
        <div className="max-w-3xl">
          <p className="font-script text-3xl md:text-5xl text-white text-glow-white mb-1">
            Keeping Your Property
          </p>
          <h1 className="font-display text-5xl md:text-7xl lg:text-8xl text-white leading-[0.95] text-glow-white">
            LOOKING <span className="text-[#4fd4ff] text-glow">ITS BEST.</span>
          </h1>
          <div className="h-1.5 w-64 md:w-96 mt-4 rounded-full bg-gradient-to-r from-[#35c6f4] to-transparent" />

          {/* Phone highlight */}
          <a
            href={company.phoneHref}
            className="inline-flex items-center gap-3 mt-8 group"
          >
            <span className="grid place-items-center h-12 w-12 rounded-full bg-[#4fd4ff] text-[#062038] glow-cyan group-hover:scale-110 transition-transform">
              <Phone className="h-6 w-6" />
            </span>
            <span className="font-display text-3xl md:text-5xl text-white tracking-wide text-glow-white">
              {company.phone}
            </span>
          </a>

          {/* Service pills */}
          <div className="flex flex-wrap items-center gap-x-3 gap-y-2 mt-8">
            {company.pills.map((p, i) => (
              <React.Fragment key={p}>
                <span className="font-cond uppercase tracking-[0.2em] text-white text-sm md:text-base">
                  {p}
                </span>
                {i < company.pills.length - 1 && (
                  <span className="h-2 w-2 rounded-full bg-[#35c6f4]" />
                )}
              </React.Fragment>
            ))}
          </div>

          <div className="flex flex-wrap gap-4 mt-10">
            <a href="#contact">
              <Button className="bg-[#35c6f4] hover:bg-[#0a6bb0] text-[#071a2f] hover:text-white font-cond uppercase tracking-widest text-base rounded-full px-8 py-6 shadow-lg shadow-[#35c6f4]/30 transition-colors">
                Get a Quote Today
              </Button>
            </a>
            <a href="#services">
              <Button
                variant="outline"
                className="border-white/70 bg-white/5 text-white hover:bg-white hover:text-[#071a2f] font-cond uppercase tracking-widest text-base rounded-full px-8 py-6 transition-colors"
              >
                Our Services
              </Button>
            </a>
          </div>
        </div>
      </div>

      {/* Right side family legacy note (desktop) */}
      <div className="hidden lg:flex flex-col items-end gap-1 absolute right-10 bottom-24 z-10 text-right">
        <div className="font-script text-3xl text-[#7fd8f7] leading-tight">
          {company.values.map((v) => (
            <div key={v}>{v}</div>
          ))}
        </div>
        <p className="text-slate-200 text-sm max-w-[220px] mt-3">
          {company.subTagline}
        </p>
      </div>
    </section>
  );
};

export default Hero;
